<template>
    <vwc-textfield ref="textfield" class="text-field" :required="required" :autovalidate="autoValidate" :validationmessage="validationMessage"
                   @input="$emit('textChanged', $event.target.value)" dense
                   @focusout="$emit('textFieldFocusout')"
                   :label="label" :placeholder="placeholder" :value="value" :pattern="pattern" :helper="helper"
                   :disabled="disabled" :charcounter="charCounter" :maxlength="maxLength" outlined>
    </vwc-textfield>
</template>

<script>
    export default {
        name: "text-field",
        props: {
            required: {
                type: Boolean,
                default: true
            },
            autoValidate: {
                type: Boolean,
                default: true
            },
            validationMessage: {
                type: String,
                default: 'Required field'
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            value: {
                type: String,
                default: ''
            },
            pattern: {
                type: String,
                default: ''
            },
          helper: {
            type: String,
            default: ''
          },
          disabled: {
            type: Boolean,
            default: false
          },
          charCounter: {
            type: Boolean,
            default: false
          },
          maxLength: {
            type: String,
            default: null
          },
          customValidator: {
            type: Function,
            default: null
          }
        },
      updated() {
        if (!this.customValidator) {
          return;
        }
        const validationResult = this.customValidator(this.value);
        const textfieldElement = this.$refs.textfield;
        if (textfieldElement) {
          if (validationResult !== true) {
            textfieldElement.setCustomValidity(validationResult || this.validationMessage);
          } else {
            textfieldElement.setCustomValidity('');
          }
          textfieldElement.reportValidity();
        }
      }
    }
</script>

<style scoped>
    .text-field {
        width: 100%;
    }
</style>
